import React, { useMemo } from 'react';
import './FloatingConfetti.css';

const FloatingConfetti = ({ colors, count = 50, intensity = 'medium' }) => {
  const intensityMap = {
    subtle: 30,
    medium: 50,
    heavy: 100
  };

  const particleCount = intensityMap[intensity] || count;

  const particles = useMemo(() => {
    const newParticles = [];
    for (let i = 0; i < particleCount; i++) {
      newParticles.push({
        id: i,
        left: Math.random() * 100,
        animationDuration: 3 + Math.random() * 5,
        animationDelay: Math.random() * 5,
        color: colors[Math.random() * colors.length | 0],
        size: 5 + Math.random() * 10,
        rotation: Math.random() * 360
      });
    }
    return newParticles;
  }, [particleCount, colors]);

  return (
    <div className="confetti-container">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="confetti-piece"
          style={{
            left: `${particle.left}%`,
            animationDuration: `${particle.animationDuration}s`,
            animationDelay: `${particle.animationDelay}s`,
            backgroundColor: particle.color,
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            transform: `rotate(${particle.rotation}deg)`
          }}
        />
      ))}
    </div>
  );
};

export default FloatingConfetti;
